import { DeviceStreamConfigurationType } from "@formant/core/model/DeviceStreamConfigurationType";

export function typeToString(
    type: DeviceStreamConfigurationType["type"],
): string {
    switch (type) {
        case "hardware":
            return "Hardware Video";
        case "custom":
            return "API";
        case "directory-watch":
            return "Directory Watch";
        case "file-tail":
            return "File Tail";
        case "ros-localization":
            return "ROS Localization";
        case "ros-transform-tree":
            return "ROS Transform Tree";
        case "ros-topic":
            return "ROS Topic";
    }
}
